import React from 'react';
import {
    Datagrid,
    TextField,
    DateField,
    EditButton,
    BooleanField,
    Show,
    SimpleShowLayout,
    ArrayField,
    FileField,
    ReferenceField,
    TopToolbar,
    Labeled,
    useRecordContext,
} from 'react-admin';
import { Box } from '@mui/material';

import OrderCloneButton from './OrderCloneButton';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

const CheckBoxIconBlack = () => (
    <CheckBoxIcon style={{ color: 'black' }} />
);

const CheckBoxOutlineBlankIconBlack = () => (
    <CheckBoxOutlineBlankIcon style={{ color: 'black' }} />
);

const CheckBoxIconRed = () => (
    <CheckBoxIcon style={{ color: 'red' }} />
);

const CheckBoxOutlineBlankIconRed = () => (
    <CheckBoxOutlineBlankIcon style={{ color: 'red' }} />
);

const CheckBoxIconBlue = () => (
    <CheckBoxIcon style={{ color: 'blue' }} />
);

const CheckBoxOutlineBlankIconBlue = () => (
    <CheckBoxOutlineBlankIcon style={{ color: 'blue' }} />
);

const MyEmailField = ({ source, text }) => {
    const record = useRecordContext();
    return record && record[source] != null
        ? <a target="_blank" rel="noreferrer" href={`mailto:${record[source]}`}>{text}</a>
        : null;
};

const OrderShowActions = ({ basePath, data, resource }) => (
    <TopToolbar>
        <OrderCloneButton
            record={data}
            basePath={basePath}
            mr={5}
        />
        <EditButton basePath={basePath} record={data} />
    </TopToolbar>
);

export const OrderShow = (props) => {
    return (
        <Show actions={<OrderShowActions />} {...props}>
            <SimpleShowLayout>
                <Box display="flex" >
                    <Box display="flex" flexWrap="wrap" flexGrow={3}>
                        <Box display="inline-flex" flexDirection="column" flexGrow={1}>
                            <Labeled label="Order Number">
                                <TextField source="Order_Num" />
                            </Labeled>
                            <Labeled label="PO#">
                                <TextField source="PO_Num" />
                            </Labeled>
                            <Labeled label="Order Date">
                                <DateField source="Order_Date" locales="en-US" options={{ timeZone: 'UTC' }} />
                            </Labeled>
                        </Box>
                    </Box>
                    <Box display="flex" flexWrap="wrap" flexGrow={3}>
                        <Box display="inline-flex" flexDirection="column" flexGrow={1}>
                            <Labeled label="Trucking Company">
                                <ReferenceField source="CarrierID" reference="truckingcompanies" sortable={false} link="show">
                                    <TextField source="Trucking_Company" />
                                </ReferenceField>
                            </Labeled>
                            <Labeled label="Customer">
                                <ReferenceField source="CustomerID" reference="customers" sortable={false} link="show">
                                    <TextField source="Customer" />
                                </ReferenceField>
                            </Labeled>
                        </Box>
                    </Box>
                    <Box display="flex" flexWrap="wrap" flexGrow={3}>
                        <Box display="inline-flex" flexDirection="column" flexGrow={1}>
                            <Labeled label="Pick-Up Date">
                                <DateField source="PickUp_Date" sortable={false} locales="en-US" options={{ timeZone: 'UTC' }} />
                            </Labeled>
                            <Labeled label="Delivery Date">
                                <DateField source="Delivery_Date" sortable={false} locales="en-US" options={{ timeZone: 'UTC' }} />
                            </Labeled>
                        </Box>
                    </Box>
                    <Box display="flex" flexWrap="wrap" flexGrow={3}>
                        <Box display="inline-flex" flexDirection="column" flexGrow={1}>
                            <Labeled label="Order Type">
                                <TextField source="Order_Type" />
                            </Labeled>
                        </Box>
                    </Box>
                    <Box display="flex" flexWrap="wrap" flexGrow={3}>
                        <Box display="inline-flex" flexDirection="column" flexGrow={1}>
                            <Labeled label="Pending">
                                <BooleanField source="Pending" TrueIcon={CheckBoxIconBlack} FalseIcon={CheckBoxOutlineBlankIconBlack} />
                            </Labeled>
                            <Labeled label="Emailed PickUp Notice">
                                <BooleanField source="Emailed_PickUp_Notice" TrueIcon={CheckBoxIconBlue} FalseIcon={CheckBoxOutlineBlankIconBlue} />
                            </Labeled>
                            <Labeled label="Emailed Trucking Manifest">
                                <BooleanField source="Emailed_Trucking_Manifest" TrueIcon={CheckBoxIconRed} FalseIcon={CheckBoxOutlineBlankIconRed} />
                            </Labeled>
                        </Box>
                    </Box>
                    <Box display="flex" flexWrap="wrap" flexGrow={3}>
                        <Box display="inline-flex" flexDirection="column" flexGrow={1}>
                            <Labeled label="Last Modified By">
                                <TextField source="Modified_By" emptyText="-" />
                            </Labeled>
                            <Labeled label="Last Modified At">
                                <TextField source="Modified_At" emptyText="-" />
                            </Labeled>
                        </Box>
                    </Box>
                </Box>
                <ArrayField label="Preview Docs" source="OrderDetails">
                    <Datagrid
                        bulkActionButtons={false}
                        rowClick={false}
                        sx={{
                            '& .MuiTableCell-paddingCheckbox': { display: 'none' }
                        }}
                    >
                        <TextField label="Release #" source="Release_Num"/>
                        <ReferenceField label="Pickup Location" source="PickupLocationID" reference="pickuplocations" sortable={false} link="show">
                            <TextField source="Pickup_Location" />
                        </ReferenceField>
                        <ReferenceField label="Delivery Location" source="DeliveryLocationID" reference="deliverylocations" sortable={false} link="show">
                            <TextField source="Delivery_Location" />
                        </ReferenceField>
                        <FileField label="Bill-of-Lading" source="Bill_Of_Lading_URL" target="_blank" title="View Bill Of Lading PDF"/>
                        <FileField label="Trucking Manifests" source="Trucking_Manifest_URL" target="_blank" title="View Trucking Manifest PDF" />
                        <FileField label="Packing Slips" source="Packing_Slip_URL" target="_blank" title="View Packing Slip PDF" />
                        <FileField label="SKU Labels" source="SKU_URL" target="_blank" title="View SKU PDF" />
                    </Datagrid>
                </ArrayField>
                <ArrayField label="Email Links" source="OrderDetails">
                    <Datagrid
                        bulkActionButtons={false}
                        rowClick={false}
                        sx={{
                            '& .MuiTableCell-paddingCheckbox': { display: 'none' },
                            '& .MuiTable-root': { tableLayout: 'fixed', width: 'auto' },
                            '& .MuiTableCell-root': { textAlign: 'left' },
                            '& .MuiTableCell-head': { textAlign: 'left' }
                        }}
                    >
                        <TextField label="Release #" source="Release_Num"/>
                        <MyEmailField label="Order Docs" source="PUN_Email" text="Email Order Docs" />
                        <MyEmailField label="Trucking Manifests" source="TM_Email" text="Email Trucking Manifests (TMs)" />
                    </Datagrid>
                </ArrayField>
            </SimpleShowLayout>
        </Show>
    )
}

export default OrderShow;
